import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClientSetPasswordUseCase extends BaseUseCase {
    constructor(loginRepo) {
        super();
        this.loginRepo = loginRepo;
    }
    async fetchResult(req) {
        return await this.loginRepo.clientSetPassword(req);
    }
}
export default ClientSetPasswordUseCase;
